// services/student/studentLessonService.js
import axiosConfig from '../../api/axiosConfig';

const studentLessonService = {
  // Öğrencinin derslerini getir
  async getMyLessons() {
    try {
      const response = await axiosConfig.get('/ogrenci/my-lessons');
      return response.data;
    } catch (error) {
      console.error('Get my lessons error:', error);
      throw error;
    }
  }
};

export default studentLessonService;